<!--卡片：以下类型-->
<template>
  <div class="v-card">
    <el-row :gutter="10">
        <el-col :xs="24"
                :sm="cardVal.length>1?12:24"
                :md="cardVal.length>2?8:cardVal.length>1?12:24"
                :lg="cardVal.length>3?6:cardVal.length>2?8:cardVal.length>1?12:24"
                :xl="cardVal.length>5?4:cardVal.length>3?8:cardVal.length>2?8:cardVal.length>1?12:24"
                v-for="(item,index) in cardVal"
                :key="index"
                :class="getValue(JSON.parse(item.card.attr))" 
                >
      <!-- 插件1:列表 -->
      <v-list v-if="item.card.cardType=='list'" :list-val="item"></v-list>
      <!-- 插件2:图文 -->
      <v-imgText v-else-if="item.card.cardType=='imageText'" :imgtext-val="item"></v-imgText>
      <!-- 插件3:轮播 -->
      <v-carousel v-else-if="item.card.cardType=='filpper'" :carousel-val="item"></v-carousel>
      <!-- 插件4:文章 -->
      <v-article v-else-if="item.card.cardType=='article'" :article-val="item"></v-article>
    </el-col>
    </el-row>
  </div>
</template>

<script>
// import marked from 'marked'

import list from "@/components/list"
import imgtext from "@/components/imgText"
import carousel from "@/components/carousel"
import article from "@/components/article"

export default {
  name: 'v-card',
  components:{
    "v-list":list,
    "v-imgText":imgtext,
    "v-carousel":carousel,
    "v-article":article,
  },
  props: {
      cardVal: null //这样可以指定传入的类型，如果类型不对，会警告
  },
  data () {
    return {
      defaultOpen:"preview",
      cardClass:"cardOne",//card样式 
    }
  },
  created(){
    // var that = this;
    // console.log("that.cardVal::",that.cardVal);
    // that.cardClass = (that.cardVal.attr!==''&&that.cardVal.attr!==undefined)? that.getValue(JSON.parse(that.cardVal.attr)):"";

    // that.cardClass = that.getAttr(that.cardVal.card.attr,'cardClass')?that.getAttr(that.cardVal.card.attr,'cardClass'):'';
  },
  methods:{
    //转换md格式
    // mark(_value){
    //   return marked(_value);
    // },
    //获取属性值JS 遍历Key、Value字典对象
    getValue(_attr){
      console.log("_attr:::-------",_attr);
      var str = "";
      for(var key in _attr){
        // console.log("key:::",_attr[key]);
        str += _attr[key]+' ';
      }
      console.log("valuestr:::",str);
      return str;
    },
    //转换样式
    getAttr(_attr,_type){
      
      var data={};
      if(_attr!==''){
        data=JSON.parse(_attr);
        return data.[_type];
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>

</style>
